import classNames from 'classnames';
import styles from './AppParagraphs.module.scss';

const AppParagraphs = ({ content, routerPath }: any) => {
    return (
        <div
            className={classNames(styles.paragraphs, styles[routerPath[routerPath.length - 1]])}
            dangerouslySetInnerHTML={{
                __html: content.ContentParagraphs.rendered,
            }}
        ></div>
    );
};

export default AppParagraphs;
